import { WatchlistWithChildLists } from './watchlist-with-child-lists';

export const isEmptyWatchlist = (watchlist: WatchlistWithChildLists) => watchlist == null
    || ((watchlist.childLists == null || watchlist.childLists.length === 0)
        && (watchlist.elements == null || watchlist.elements.length === 0));
